export default __webpack_public_path__ + "static/media/BLR4.06d9acfa.jpg";